import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { Anchor, Label } from './styles.js';

const Link = (_a) => {
    var { iconLeft, iconRight, size = 'medium', type = 'standalone', children } = _a, props = __rest(_a, ["iconLeft", "iconRight", "size", "type", "children"]);
    const standaloneLink = type === 'standalone';
    return (React.createElement(Anchor, Object.assign({}, props, { type: type }),
        standaloneLink && iconLeft,
        React.createElement(Label, { iconLeft: Boolean(standaloneLink && iconLeft), iconRight: Boolean(standaloneLink && iconRight), size: size, type: type }, children),
        standaloneLink && iconRight));
};

export { Link as default };
